import { render, staticRenderFns } from "./DisplayErrors.vue?vue&type=template&id=1993ac4e&scoped=true&"
import script from "./DisplayErrors.vue?vue&type=script&lang=ts&"
export * from "./DisplayErrors.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayErrors.vue?vue&type=style&index=0&id=1993ac4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993ac4e",
  null
  
)

export default component.exports